import { composeFilters } from '@iheartjane/menu';
import { useMemo } from 'react';

import { useSearchContext } from '@jane/search/hooks';
import { MIN_REVIEWS_QUERY } from '@jane/search/util';
import { useBrandSpecialsContext, useMenu } from '@jane/shared-ecomm/providers';

export const useComposeMenuFilters = (
  filters: Array<string | null | undefined>
) => {
  const { brandSpecialFilter } = useBrandSpecialsContext();
  const { staticFilters } = useMenu();
  const { searchState } = useSearchContext();

  const goldFilterValues = searchState.filters?.['has_brand_discount'] ?? [];
  const isFilteredByGold = goldFilterValues?.length > 0;
  const ratingFilterValues =
    searchState.bucketFilters?.['aggregate_rating'] ?? [];
  const isFilteredByRating = ratingFilterValues?.length > 0;

  return useMemo(
    () =>
      composeFilters(
        staticFilters,
        isFilteredByRating ? MIN_REVIEWS_QUERY : '',
        isFilteredByGold ? brandSpecialFilter : '',
        ...filters
      ),
    [
      staticFilters,
      isFilteredByRating,
      isFilteredByGold,
      brandSpecialFilter,
      filters,
    ]
  );
};
